angular.module('dnecom').controller('CampaignsOverviewController', ["$scope", "$http", "StatisticsTabs", function($scope, $http, StatisticsTabs) {
    $scope.tabs = StatisticsTabs;

    $scope.init = {
        common: function() {
            $scope.store = TemplateData.value('store');

            var tabs = StatisticsTabs;

            tabs.$tabs = [
                {label: '1 day', interval: 1, items: []},
                {label: '7 days', interval: 7, items: []},
                {label: '1 month', interval: 30, items: []},
                {label: '3 months', interval: 90, items: []}
            ];

            tabs.change = function(index) {
                if (false === tabs.isActive(index) && tabs.has(index)) {
                    var tab = tabs.$tabs[index];

                    if (0 === tab.items.length) {
                        $http
                            .post(Routing.generate('campaign_statistics_all', {
                                store: $scope.store.id,
                                interval: tab.interval
                            }))
                            .then(function(response) {
                                tab.items = response.data;
                                tabs.$current = index;
                            });
                    } else {
                        tabs.$current = index;
                    }
                }
            };

            tabs.change(0);
        }
    };
}]);
